import decodeJWT from 'jwt-decode';
import MSALUtil from './MSALUtil';

// Do not call functions that change the user's authenticated state (login, logout) outside the react context provided by MsalProvider as the components inside the context may not properly update.
// If you want to login/logout or execute any function that modifies user's authenticated state use `src/hooks/useAuth`
class Auth {
    constructor() {
        this.msalInstance = null;
        this.scopes = [];
    }

    getToken() {
        MSALUtil.acquireTokenAsync();
        return sessionStorage.getItem('access_token') || sessionStorage.getItem('cc_access_token');
    }

    currentUser() {
        return this.getUserFromToken(this.getToken());
    }

    getUserFromToken(token) {
        if (!token) {
            return {};
        }
        const decoded = decodeJWT(token);
        return {
            name: decoded.name,
            firstName: decoded.given_name,
            lastName: decoded.family_name,
            emails: decoded.emails,
            city: decoded.city,
            country: decoded.country,
        };
    }

    isExpired() {
        if (!this.getToken()) {
            return true;
        }

        const decoded = decodeJWT(this.getToken());

        if (!decoded.exp) {
            return true;
        }

        return Date.now() > decoded.exp * 1000;
    }
}

export default new Auth();
